import axios from 'axios';

const getUsers = (params) => axios.get('/fornecedor/user', {
  params,
});

const save = (idFornecedor, data) => {
  if (data.id != null) {
    return axios.put(`/fornecedor/${idFornecedor}/user/${data.id}`, data);
  }
  return axios.post(`/fornecedor/${idFornecedor}/user`, data);
};

const inativar = (id, data) => axios.put(`/fornecedor/user/${id}/situacao`, data);

export default {
  getUsers,
  save,
  inativar,
};
